// extracted by mini-css-extract-plugin
export default {"link":"styles_link__LxY3v","navLink":"styles_navLink__1JmPm"};